import * as React from 'react';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box } from '@mui/material';
import color from '../../../../config/Colors';
export interface TableHeadContent {
    label: string;
    alight: 'center' | 'right' | 'left' | 'inherit' | 'justify' | undefined;
}

type Props = {
    tableHead: TableHeadContent[];
    tableRow: JSX.Element;
};

export default function TableUploadPermit(props: Props) {
    return (
        <Box
            display={'flex'}
            flexDirection={'column'}
            sx={{
                alignItems: 'center',
                padding: '20px',
                '&.MuiPaper-root': {
                    borderRadius: 'none',
                },
            }}
            width={'100%'}
        >
            <TableContainer
                component={Paper}
                sx={{
                    borderRadius: '0px',
                    boxShadow: 'none',
                }}
            >
                <Table aria-label="simple table">
                    <TableHead sx={{ background: color.lightPrimary, padding: '16px' }}>
                        <TableRow>
                            {props.tableHead.map((item, index) => {
                                return (
                                    <TableCell
                                        key={index}
                                        align={item.alight}
                                        sx={{
                                            fontWeight: 500,
                                            fontSize: { xs: '14px !important' },
                                            color: color.textPrimary,
                                            padding: '10px !important',
                                        }}
                                    >
                                        {item.label}
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    </TableHead>
                    {props.tableRow}
                </Table>
            </TableContainer>
        </Box>
    );
}
